import { render, staticRenderFns } from "./Rating.vue?vue&type=template&id=7a3b201f&scoped=true"
import script from "./Rating.vue?vue&type=script&lang=ts"
export * from "./Rating.vue?vue&type=script&lang=ts"
import style0 from "./Rating.vue?vue&type=style&index=0&id=7a3b201f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3b201f",
  null
  
)

export default component.exports